import React, { PureComponent } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import Select from '4all-ui/components/Select';
import EditableTitle from '../../components/EditableTitle';
import Radio from '../../components/Radio';
import FormFooter from '../../components/FormFooter';
import GenericSelectList from '../../components/GenericSelectList';
import GenericList from '../../components/GenericList';
import withCreateUhuuMenu from '../../containers/CreateUhuuMenu';
import Storage from '../../helpers/storage';
import * as styles from './style';
import {
  SALE_TYPES,
  NEW_MENU_STORAGE_KEY,
  SELECT_SERVICES_UHUU_LIST,
  PATHS,
} from '../../helpers/constants';
import {
  serializeAccounts,
  serializeEventSectors,
  serializeSectorBenefits,
  serializeSelectedEvents,
  serializeEvents,
} from '../../helpers/uhuu';
import { GroupInfo } from '../../styles/customComponents';
import EventListItem from '../../components/EventListItem';
import Helper from '../../helpers/Helper';
import withMerchant from '../../containers/Merchant';
import { withMenus } from '../../containers/Menus';

const INITIAL_ERROR_STATE = {
  account: {
    isInvalid: false,
    message: null,
  },
  serviceTypes: {
    isInvalid: false,
    message: null,
  },
  saleType: {
    isInvalid: false,
    message: null,
  },
  title: {
    isInvalid: false,
    message: null,
  },
  events: {
    isInvalid: false,
    message: null,
  },
  sectors: {
    isInvalid: false,
    message: null,
  },
  benefits: {
    isInvalid: false,
    message: null,
  },
};
class CreateMenuUhuu extends PureComponent {
  state = {
    id: null,
    title: '',
    saleType: SALE_TYPES.generalMenu,
    serviceTypes: null,
    account: null,
    marketplaces: [],
    published: null,
    categories: [],
    errors: { ...INITIAL_ERROR_STATE },
  };

  componentDidMount() {
    const { getMenus, getAccounts } = this.props;

    getMenus();
    getAccounts();
    this.getDataFromLocalStorage();
  }

  componentDidUpdate() {
    const {
      isReceiveEventsFinished,
      menus,
      syncStorageEvents,
      validateMenuEvents,
      finishReceiveEvents,
    } = this.props;
    const { account, saleType } = this.state;
    if (isReceiveEventsFinished) {
      const menuData = Storage.getLocalStorage(NEW_MENU_STORAGE_KEY);
      if (menuData && menuData.uhuuEvents) {
        syncStorageEvents(menuData.uhuuEvents);
      }
      validateMenuEvents(menus, account.id, saleType, menuData ? menuData.id : null);
      finishReceiveEvents();
    }
  }

  getDataFromLocalStorage() {
    const menuData = Storage.getLocalStorage(NEW_MENU_STORAGE_KEY);
    const { serviceTypes, saleType } = this.state;
    if (menuData) {
      this.setState({
        id: menuData.id || null,
        title: menuData.title || menuData.name,
        serviceTypes: menuData.serviceTypes || serviceTypes,
        saleType: menuData.menuUhuuTypeId || menuData.saleType || saleType,
        account: menuData.account
          ? {
              id: menuData.account.id,
              label: menuData.account.label,
              value: menuData.account.id,
            }
          : null,
        marketplaces: menuData.marketplaces,
        published: !!menuData.published,
        categories: menuData.categories || [],
      });
      if (menuData.account) {
        this.props.getEvents(menuData.account.id);
      }
    }
  }

  handleSaleTypeChange = e => {
    const { validateMenuEvents, clearSectors, menus } = this.props;
    const { account, id } = this.state;
    this.setState({
      [e.target.name]: Number(e.target.value),
    });
    validateMenuEvents(menus, account ? account.id : null, Number(e.target.value), id);
    if (Number(e.target.value) === SALE_TYPES.generalMenu) {
      clearSectors();
    }
  };

  handleTitle = e => this.setState({ title: e.target.value });

  onSelectAccount = acc => {
    this.setState({
      account: acc,
      saleType: this.state.saleType,
    });
    this.props.getEvents(acc.id);
  };

  onChangeType = value => {
    this.setState({
      serviceTypes: value,
    });
  };

  hasEventSelected = () => {
    const { events } = this.props;
    return events.some(ev => {
      return ev.exhibitions.some(ap => {
        return ap.repetitions.some(rep => rep.checked);
      });
    });
  };

  hasSectorSelected = () => {
    const { events } = this.props;
    return events.some(ev => {
      return ev.exhibitions.some(ap => {
        return ap.repetitions.some(rep => {
          return rep.sectors.some(sec => sec.checked);
        });
      });
    });
  };

  hasBenefitSelected = () => {
    const { events } = this.props;
    let hasSectorWithNoBenefit = false;
    events.forEach(ev => {
      ev.exhibitions.forEach(ap => {
        ap.repetitions.forEach(rep => {
          if (rep.checked) {
            hasSectorWithNoBenefit = rep.sectors
              .filter(sec => sec.checked)
              .every(sec => sec.benefits.some(ben => ben.checked));
          }
          if (hasSectorWithNoBenefit) {
            return;
          }
        });
        if (hasSectorWithNoBenefit) {
          return;
        }
      });
      if (hasSectorWithNoBenefit) {
        return;
      }
    });
    return hasSectorWithNoBenefit;
  };

  validateForm = () => {
    let errors = { ...INITIAL_ERROR_STATE };
    const { account, saleType, title, serviceTypes } = this.state;
    const isEventSelected = this.hasEventSelected();
    const isSectorSelected =
      saleType === SALE_TYPES.generalMenu ||
      saleType === SALE_TYPES.defaultMenu ||
      this.hasSectorSelected();
    const isBenefitSelected =
      saleType === SALE_TYPES.generalMenu ||
      saleType === SALE_TYPES.defaultMenu ||
      this.hasBenefitSelected();
    if (!title) {
      errors = {
        ...errors,
        title: {
          isInvalid: true,
          message: 'Você precisa informar um título para o cardápio.',
        },
      };
    } else if (!account) {
      errors = {
        ...errors,
        account: {
          isInvalid: true,
          message: 'Você precisa selecionar uma conta/produtor para o cardápio do evento.',
        },
      };
    } else if (!saleType) {
      errors = {
        ...errors,
        saleType: {
          isInvalid: true,
          message: 'Você precisa selecionar tipo de venda para o cardápio.',
        },
      };
    } else if (!serviceTypes) {
      errors = {
        ...errors,
        serviceTypes: {
          isInvalid: true,
          message: 'Você precisa selecionar um tipo de cardápio para o evento.',
        },
      };
    } else if (!isEventSelected) {
      errors = {
        ...errors,
        events: {
          isInvalid: true,
          message: 'Você precisa selecionar um evento e pelo menos uma repetição do mesmo.',
        },
      };
    } else if (!isSectorSelected) {
      errors = {
        ...errors,
        sectors: {
          isInvalid: true,
          message: 'Você precisa selecionar pelo menos um setor.',
        },
      };
    } else if (!isBenefitSelected) {
      errors = {
        ...errors,
        benefits: {
          isInvalid: true,
          message: 'Você precisa selecionar pelo menos um benefício para cada setor.',
        },
      };
    }

    this.setState({
      errors,
    });
    return Object.keys(errors).every(key => !errors[key].isInvalid);
  };

  onProceed = () => {
    const { events, history } = this.props;
    const {
      id,
      title,
      account,
      serviceTypes,
      saleType,
      categories,
      marketplaces,
      published,
    } = this.state;
    let menu = {};

    if (this.validateForm()) {
      menu = {
        id,
        title,
        serviceTypes: serviceTypes.length ? serviceTypes : [serviceTypes],
        saleType,
        account,
        uhuuEvents: serializeSelectedEvents(events, account, saleType),
        categories,
        marketplaces,
        published,
      };
      Storage.setLocalStorage(NEW_MENU_STORAGE_KEY, menu, 1000000);
      history.push(PATHS.selectProducts);
    }
  };

  onCancel = () => {
    Storage.removeLocalStorage(NEW_MENU_STORAGE_KEY);
    this.props.history.goBack();
  };

  getError = () => {
    const { errors } = this.state;
    const errorIndex = Object.keys(errors).find(
      key => errors[key].isInvalid || errors[key].isInvalidQtd
    );
    return errorIndex ? errors[errorIndex] : {};
  };

  render() {
    const {
      events,
      accounts,
      isLoading,
      merchant,
      toggleAllSectors,
      toggleAllBenefits,
      selectSector,
      selectBenefit,
      toggleAllBenefitsInAccordion,
    } = this.props;
    const { title, errors, account, serviceTypes, saleType } = this.state;
    const accountsFormatted = serializeAccounts(accounts);
    const { sectorsFormatted, repetitions } = serializeEventSectors(events);
    const benefitsFormatted = serializeSectorBenefits(events);
    const serializedEvents = serializeEvents(events);
    return (
      <styles.Container>
        <styles.Header>
          <EditableTitle
            placeholder="Nome do cardápio"
            onChange={this.handleTitle}
            title={title}
            error={errors.title.isInvalid}
            maxLength={45}
          />
        </styles.Header>
        <styles.Content>
          <styles.Box>
            <GroupInfo
              styles={{ marginRight: '60px', width: '22.5%' }}
              descStyles={{ width: 'auto' }}
            >
              <label>Conta ou Produtor</label>
              <p>Selecione a conta ou produtor do evento</p>
              <Select
                id="dropdown-accounts-uhuu"
                options={accountsFormatted}
                onChange={this.onSelectAccount}
                value={account}
                error={errors.account.isInvalid}
              />
            </GroupInfo>
            <GroupInfo
              styles={{ marginRight: '60px', width: '22.5%' }}
              descStyles={{ width: 'auto' }}
            >
              <label>Tipo de Cardápio</label>
              <p>Selecione a forma de retirada</p>
              <Select
                id="dropdown-service-types-uhuu"
                options={Helper.serializeServiceTypes(SELECT_SERVICES_UHUU_LIST, merchant)}
                value={serviceTypes}
                onChange={this.onChangeType}
                closeMenuOnSelect
                error={errors.serviceTypes.isInvalid}
              />
            </GroupInfo>
            <GroupInfo styles={{ width: '45%' }} descStyles={{ width: 'auto' }}>
              <label>Tipo de Venda</label>
              <p style={{ marginBottom: '21px' }}>
                Selecione como gostaria de ofertar seus produtos
              </p>
              <styles.RadioContainer>
                <Radio
                  id="inp-type-sale-advance"
                  label="Venda Antecipada"
                  desc="(específico)"
                  name="saleType"
                  checked={saleType === SALE_TYPES.specificMenu}
                  value={SALE_TYPES.specificMenu}
                  onChange={this.handleSaleTypeChange}
                />
                <Radio
                  id="inp-type-sale-full"
                  label="Cardápio Completo"
                  desc="(genérico)"
                  name="saleType"
                  checked={saleType === SALE_TYPES.generalMenu}
                  value={SALE_TYPES.generalMenu}
                  onChange={this.handleSaleTypeChange}
                />
                <Radio
                  id="inp-type-sale-default"
                  label="Cardápio Promocional"
                  desc="(padrão)"
                  name="saleType"
                  checked={saleType === SALE_TYPES.defaultMenu}
                  value={SALE_TYPES.defaultMenu}
                  onChange={this.handleSaleTypeChange}
                />
              </styles.RadioContainer>
            </GroupInfo>
          </styles.Box>
          {account && (
            <styles.Box error={errors.events.isInvalid}>
              <GenericList
                id="select-events"
                title="Selecione o Evento"
                desc="Selecione o evento e as sessões onde o cardápio aparecerá"
                options={serializedEvents}
                isLoading={isLoading}
                CustomItem={EventListItem}
                saleType={saleType}
                customListStyles={{
                  height: '305px',
                }}
              />
            </styles.Box>
          )}
          {saleType === SALE_TYPES.specificMenu && (
            <styles.BoxInline>
              {this.hasEventSelected() && (
                <styles.Box error={errors.sectors.isInvalid}>
                  <GroupInfo
                    labelStyles={{ fontSize: '24px' }}
                    descStyles={{ width: 'auto' }}
                    styles={{ paddingLeft: '15px' }}
                  >
                    <label>Setor</label>
                    <p>Selecione os setores que o cardápio aparecerá.</p>
                    <GenericSelectList
                      id="select-sectors"
                      options={sectorsFormatted}
                      selectOption={({ option }) => selectSector(option, repetitions)}
                      toggleAll={() => toggleAllSectors(repetitions)}
                      leftCheckbox
                    />
                  </GroupInfo>
                </styles.Box>
              )}
              {this.hasSectorSelected() && (
                <styles.Box error={errors.benefits.isInvalid}>
                  <GroupInfo
                    labelStyles={{ fontSize: '24px' }}
                    descStyles={{ width: 'auto' }}
                    styles={{ paddingLeft: '15px' }}
                  >
                    <label>Benefício</label>
                    <p>Selecione os benefícios que o cardápio aparecerá.</p>
                    <GenericSelectList
                      id="select-benefits"
                      hasAccordion
                      options={benefitsFormatted}
                      selectOption={({ option, fatherId }) => selectBenefit(option, fatherId)}
                      toggleAll={() => toggleAllBenefits(repetitions)}
                      toggleAllItemsInAccordion={toggleAllBenefitsInAccordion}
                      leftCheckbox
                    />
                  </GroupInfo>
                </styles.Box>
              )}
            </styles.BoxInline>
          )}
        </styles.Content>
        <FormFooter
          cancelAction={this.onCancel}
          nextAction={this.onProceed}
          errorMessage={this.getError().message}
        />
      </styles.Container>
    );
  }
}

CreateMenuUhuu.propTypes = {
  getMenus: PropTypes.func,
  getAccounts: PropTypes.func,
  isReceiveEventsFinished: PropTypes.bool,
  menus: PropTypes.object,
  syncStorageEvents: PropTypes.func,
  isLoading: PropTypes.bool,
  validateMenuEvents: PropTypes.func,
  finishReceiveEvents: PropTypes.func,
  clearSectors: PropTypes.func,
};

CreateMenuUhuu.defaultProps = {
  getMenus: null,
  getAccounts: null,
  isReceiveEventsFinished: false,
  menus: {},
  syncStorageEvents: null,
  isLoading: false,
  validateMenuEvents: null,
  finishReceiveEvents: null,
  clearSectors: null,
};

CreateMenuUhuu.defaultProps = {};

const CreateMenuUhuuComponent = compose(
  withMenus,
  withMerchant,
  withCreateUhuuMenu
)(CreateMenuUhuu);

export default CreateMenuUhuuComponent;



// WEBPACK FOOTER //
// ./src/screens/CreateMenuUhuu/index.js